import { render, staticRenderFns } from "./MyPersonalLoans.vue?vue&type=template&id=2a796c71&"
import script from "./MyPersonalLoans.vue?vue&type=script&lang=js&"
export * from "./MyPersonalLoans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports